import React, { useEffect } from 'react';
import { Routes, Route } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";
import Sidebar from '../CaspLayout/sidebar';

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from './AuthProtected';
import ProtectedAuthorizedRoute from './ProtectedAuthorizedRoute';

const Index = () => {
    return (
        <React.Fragment>
            <Routes>
                <Route>
                    {publicRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <NonAuthLayout>
                                    {route.component}
                                </NonAuthLayout>
                            }
                            key={idx}
                            exact={true}
                        />
                    ))}
                </Route>

                <Route>
                    {authProtectedRoutes.map((route, idx) => (
                        <Route element={<AuthProtected >
                            <ProtectedAuthorizedRoute includedRoles={route?.includedRoles} excludedRoles={route?.excludedRoles}>
                                <VerticalLayout>{route.component}</VerticalLayout>
                            </ProtectedAuthorizedRoute>
                        </AuthProtected>}
                        path={route.path} key={idx} exact={true}     
                        /> 
                    ))}
                </Route>
            </Routes>
        </React.Fragment>
    );
};

export default Index;